<template>
<div class="content-class">
	<v-tabs color="black" dark slider-color="primary">
		<v-tab :key="'dashboard'" ripple>Vue d'ensemble</v-tab>
		<v-tab-item :key="'dashboard'">
			<dashboard>
			</dashboard>
		</v-tab-item>

	</v-tabs>
</div>
</template>
<script>
import Dashboard from '../../components/dashboard/dashboard'

export default {
	components: { Dashboard }
}
</script>
<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/bots/dashboard.vue